import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";


const initState = {
    emailAddress: ''
};

export const resetpasswordData = {
    name: "User Form",
    initialState: initState,
    section: [
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "row mb-3 login-form",
            },

            fields: [
                {
                    id: "emailAddress",
                    label: "Email Address",
                    Field_Name: "Email Address",
                    fieldType: FormFieldTypes.INPUT,
                    dataField: "emailAddress",
                    fieldSetting: {
                        placeholder: "Please Enter User Name",
                        allowSpace: true,
                        textareaRows: 4,
                        isDisable: false,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0 ",
                    },
                },

            ],
        },
    ],
};
export const updatePasswordData = {
    name: "User Form",
    initialState: {
        password: "",
        confirmPassword: ""
    },
    section: [
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "row mb-3 login-form",
            },

            fields: [
                {
                    id: "password",
                    label: "Password",
                    Field_Name: "Password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "password",
                    fieldSetting: {
                        placeholder: "Please Enter Password",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0 ",
                    },
                },
                {
                    id: "confirmPassword",
                    label: "Confirm Password",
                    Field_Name: "Confirm Password",
                    fieldType: FormFieldTypes.PASSWORD,
                    dataField: "confirmPassword",
                    fieldSetting: {
                        placeholder: "Please Enter Password",
                        allowSpace: true,
                        textareaRows: 4,
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-12 col-md-12 validation-left-0 ",
                    },
                },

            ],
        },
    ],
};
